import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalog } from "../../redux/actions";

function getContrastTextColor(bgColor) {
    // Extrae los valores RGB del color en formato hex (#RRGGBB)
    const r = parseInt(bgColor.substr(1, 2), 16);
    const g = parseInt(bgColor.substr(3, 2), 16);
    const b = parseInt(bgColor.substr(5, 2), 16);

    // Calcula el brillo relativo usando la fórmula de luminancia
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b);

    // Si el color es claro, usa texto oscuro; si es oscuro, usa texto claro
    return luminance > 186 ? "#000000" : "#000000"; // -> fff
}

export const useStatusLeadColor = () => {
    const dispatch = useDispatch();

    const { announcementStatusList } = useSelector((state) => state.catalogRedux);

    useEffect(() => {
        dispatch(getCatalog({ keys: ["announcementStatus"] }))
    }, [])

    const getDetailStatusColor = (statusId, substatusId) => {
        if(!announcementStatusList || !statusId) return {
            textColor: 'text-white',
            backgroundColor: 'bg-gray-500',
            status: '',
            substatus: ''
        }
        const statusItem = announcementStatusList?.find(v => statusId == v.id)
        const subStatusItem = statusItem?.substatus?.find(v => v.id == substatusId)
        return {
            textColor: getContrastTextColor(statusItem?.color || '#fff'),
            backgroundColor: statusItem?.color || 'bg-gray-500',
            name: statusItem?.name || 'no name',
            substatusName: subStatusItem ? subStatusItem?.name : ''
        }
    }

  return [announcementStatusList, getDetailStatusColor]; 
}
export default useStatusLeadColor;